import { makeObservable, observable, action } from 'mobx';
import { IRecordsOrderRow } from '../../../swagger/gd/record';
import { IRoundsRow } from '../../../swagger/gd/round';
import { IDeviceRow } from '../../../swagger/gd/codelist';

class WaitingStore {
  data: IRecordsOrderRow[] = [];
  recordRounds: IRoundsRow[] = [];
  filterDevices: IDeviceRow[] = [];

  constructor() {
    makeObservable(this, {
      data: observable,
      recordRounds: observable,
      filterDevices: observable,
      setData: action,
      setRecordRounds: action,
      setFilterDevices: action
    });
  }

  setData = (rows: IRecordsOrderRow[]) => {
    this.data = rows;
  };

  setRecordRounds = (rows: IRoundsRow[]) => {
    this.recordRounds = rows;
  };

  setFilterDevices = (rows: IDeviceRow[]) => {
    this.filterDevices = rows;
  };
}

const singleton = new WaitingStore();
export default singleton;
